import React from 'react';
import { Button } from 'react-bootstrap';

const FloatingButton = ({
  text,
  variant = 'dark',
  disabled = false,
  icon,
  onClick,
  verticalAlign = 'bottom',
  horizontalAlign = 'right'
}) => {
  return (
    <Button
      size="sm"
      variant={variant}
      style={{
        position: 'fixed',
        zIndex: 999,
        ...(verticalAlign === 'top' ? { top: 0 } : { bottom: 0 }),
        ...(horizontalAlign === 'right' ? { right: 0 } : { left: 0 })
      }}
      className="m-4"
      disabled={disabled}
      onClick={onClick}
    >
      {icon && icon}
      {text}
    </Button>
  );
};

export default FloatingButton;
